import { Box, BoxProps, HStack, VStack } from '@chakra-ui/react';

import { InformationBoxPosition } from './information-box-position.enum';
import { positionStyle } from './position.style';

export type InformationBoxProps = {
	location: InformationBoxPosition;
	condition?: boolean;
	children?: React.ReactElement | Array<React.ReactElement> | string | void;
	style?: React.CSSProperties;
};

export const InformationBox = (props: InformationBoxProps & BoxProps): React.ReactElement => {
	const { location, condition, children, style, ...restProps } = props;
	const showBox = Boolean(typeof condition === 'undefined' || condition);

	/*
	<div style={{ marginBottom: '15px', paddingTop: '15px', borderTop: '1px solid #eee' }}>

	*/

	// Determine stacking direction and alignment based on location
	const getStackProps = () => {
		switch (location) {
			case InformationBoxPosition.TopLeft:
				return { as: VStack, spacing: 2, justify: 'flex-start', align: 'flex-start', display: 'grid' };
			case InformationBoxPosition.TopRight:
				return { as: VStack, spacing: 2, justify: 'flex-end', align: 'flex-start', display: 'grid' };
			case InformationBoxPosition.BottomLeft:
				return { as: VStack, spacing: 2, justify: 'flex-start', align: 'flex-end', display: 'grid' };
			case InformationBoxPosition.BottomRight:
				return { as: VStack, spacing: 2, justify: 'flex-end', align: 'flex-end', display: 'grid' };
			default:
				return { as: VStack, spacing: 2, align: 'flex-start', display: 'inline-grid' };
		}
	};

	const StackComponent = getStackProps().as;
	const stackProps = { ...getStackProps() };
	delete stackProps.as;

	return showBox
		? <Box
			{...restProps}
			style={{
				...(style ?? {}),
				...positionStyle[location],
				margin: '5px',
				width: '50%',
				height: '50%',
				position: 'absolute',
				zIndex: 999,
				pointerEvents: 'none'
				// borderColor: 'red',
				// borderWidth: '1px'
			}}
		>
			<StackComponent {...stackProps}>
				{children || <></>}
			</StackComponent>
		</Box>
		: <></>;
};
